module.exports = __webpack_public_path__ + "img/add_home.beac4316.png";